<template>
  <form :id="formId" @submit="submitForm" method="post">
    <v-text-field label="Nom" v-model="model.nom" type="text" />
    <v-btn @click="addExercici">
      Afegir activitat
    </v-btn>
    <v-container
      v-for="(exercici, counter) in model.exercicis"
      v-bind:key="counter"
    >
      <v-row no-gutters>
        <v-col>
          <v-select
            :items="exercicis_options"
            v-model="exercici.id"
            dense
            :placeholder="'Selecciona una activitat'"
          />
        </v-col>
        <v-col>
          <v-text-field
            type="number"
            v-model="exercici.fase"
            label="Fase"
            dense
          />
        </v-col>
        <v-col>
          <span @click="removeExercici(counter)">
            <v-icon>delete</v-icon>
          </span>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
export default {
  data: function() {
    return {
      model: {
        nom: null,
        exercicis: [],
      },
      exercicis_options: [],
    }
  },
  props: {
    formId: {
      type: String,
      required: true,
    },
  },
  methods: {
    fillForm(data) {
      this.model.nom = data.model.nom || null
      this.model.exercicis = data.model.exercicis
      this.exercicis_options = data.exercicis
    },
    submitForm: function(e) {
      e.preventDefault()
      this.$emit("submitForm", this.$data.model)
      return false
    },
    addExercici() {
      this.model.exercicis.push({
        id: "",
        fase: "",
      })
    },
    removeExercici(index) {
      this.model.exercicis.splice(index, 1)
    },
  },
}
</script>

<style scoped />
